export const MY_VACANCIES_LIST_PATH = "/my-vacancies/";
